import React from 'react'
import './IconStyles.css';
import {HiOutlineInformationCircle} from "react-icons/hi";

export const AccountManagementIcon = (props) => (
   <div style={{minWidth: "1.75em"}}>
    <HiOutlineInformationCircle size={props.size ? props.size : "1.25em"}
                       color={props.color ? props.color : undefined}
    />
   </div>
)